module.exports = __webpack_public_path__ + "static/media/petzenpro-3.0108b689.jpg";